import React from "react";
/* Translation */
import {useTranslation} from "react-i18next";
/* Components */
import ContentHeading from "@/components/content-heading";
/* Styles */
import {header, subHeading} from "./styles";

const Header: React.FC = () => {
    const {t} = useTranslation();
    return <section className={header} title={t("media.title.title")} aria-label={t("media.title.aria-label")}>
        <ContentHeading h={"h3"}
                        className={"justify-center"}
                        backdropPosition={"left-4"}
                        fontSize={"mobile:text-3xl tablet:text-5xl"}
                        background={"bg-primary bg-opacity-40"}>
            {t("media.header.heading")}
        </ContentHeading>
        <p className={subHeading}>
            Welcome to our media centre. hearX’s products have been featured by various media outlets across the globe.
        </p>
    </section>
}

export default Header